var _path, _path2, _path3, _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStakeFail = function SvgStakeFail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 72,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#stake-fail_svg__a)",
    strokeWidth: 7.571,
    d: "M72.015 36.507c0 17.483-14.297 31.708-31.999 31.708S8.018 53.989 8.018 36.507 22.315 4.8 40.016 4.8c17.702 0 31.999 14.225 31.999 31.707Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "url(#stake-fail_svg__b)",
    strokeWidth: 7.571,
    d: "M66.975 35.493c0-17.533-14.122-31.708-31.495-31.708-17.372 0-31.494 14.175-31.494 31.708S18.108 67.2 35.48 67.2c17.373 0 31.495-14.174 31.495-31.707Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#stake-fail_svg__c)",
    strokeLinecap: "round",
    strokeWidth: 4.48,
    d: "M45.56 47.662c0-.56-3.835-1.014-8.567-1.014s-8.568.454-8.568 1.014"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.024,
    height: 13.201,
    x: 24.896,
    y: 18.751,
    fill: "#000",
    stroke: "url(#stake-fail_svg__d)",
    strokeWidth: 3.024,
    rx: 1.512
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.024,
    height: 13.201,
    x: 45.056,
    y: 18.751,
    stroke: "url(#stake-fail_svg__e)",
    strokeWidth: 3.024,
    rx: 1.512
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stake-fail_svg__a",
    x1: 40.016,
    x2: 40.016,
    y1: 1.014,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A56F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#B7379A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB970"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stake-fail_svg__b",
    x1: 39.44,
    x2: 35.432,
    y1: 99.81,
    y2: 0.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#C653C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EF420A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEED6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stake-fail_svg__c",
    x1: 37.954,
    x2: 37.941,
    y1: 49.5,
    y2: 46.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#C653C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EF420A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEED6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stake-fail_svg__d",
    x1: 26.747,
    x2: 24.328,
    y1: 10.651,
    y2: 33.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#C653C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EF420A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEED6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stake-fail_svg__e",
    x1: 46.907,
    x2: 44.489,
    y1: 10.651,
    y2: 33.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#C653C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EF420A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEED6E"
  })))));
};
export default SvgStakeFail;